import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import {
  GetAnalyticsDto,
  RoomSystemSessionsResponse,
} from "@classview/shared-types";
import {
  UseQueryOptions,
  keepPreviousData,
  useQuery,
} from "@tanstack/react-query";

export const getRoomSystemSessions = async ({
  from,
  to,
  organisationId,
  roomSystemId,
  limit,
  offset,
}: GetAnalyticsDto) => {
  const response = await axiosClient.get<RoomSystemSessionsResponse>(
    `/analytics/room-system-sessions`,
    {
      params: {
        from,
        to,
        organisationId,
        roomSystemId,
        ...(limit !== undefined && { limit }),
        ...(offset !== undefined && { offset }),
      },
    },
  );

  return response.data;
};

export function useGetRoomSystemSessions(
  {
    from,
    to,
    organisationId,
    roomSystemId,
    pageIndex = 0,
    pageSize = 10,
  }: GetAnalyticsDto & {
    pageIndex?: number;
    pageSize?: number;
  },
  queryOptions?: Partial<
    UseQueryOptions<RoomSystemSessionsResponse, HttpError>
  >,
) {
  const offset = pageIndex * pageSize;

  return useQuery({
    queryKey: [
      "analytics",
      "room-system-sessions",
      from,
      to,
      organisationId,
      roomSystemId,
      pageIndex,
      pageSize,
    ],
    queryFn: () =>
      getRoomSystemSessions({
        from,
        to,
        organisationId,
        roomSystemId,
        limit: pageSize,
        offset,
      }),
    placeholderData: keepPreviousData,
    ...queryOptions,
  });
}
